/*
 * Copyright (c) 2025, King Living
 * PDP layout constants shared by ProductView and desktop configuration gallery.
 */

/** Minimum desktop config / customize flyout width. */
export const PDP_DESKTOP_CONFIG_PANEL_MIN_WIDTH_PX = 480;

/** Desktop `ConfigurationSelector` panel min width (px). Lightbox inset. */
export const PDP_DESKTOP_CONFIG_PANEL_WIDTH_PX = PDP_DESKTOP_CONFIG_PANEL_MIN_WIDTH_PX;

/** Gap between the gallery right edge and the desktop flyout. */
export const PDP_DESKTOP_FLYOUT_GAP_PX = 80;

/** Extra px on the measured desktop flyout width (cover the RHS fully). */
export const PDP_DESKTOP_FLYOUT_WIDTH_NUDGE_PX = 2;
